const Routes = {
  ONBOARDING: '/:jobPostAlias',
  STEP_1: '/:jobPostAlias/step-1',
  STEP_2: '/:jobPostAlias/step-2',
  STEP_3: '/:jobPostAlias/step-3',
  GREETINGS: '/:jobPostAlias/greetings',
};

export default Routes;
